import { handleActions, combineActions } from "redux-actions";

import homeInsuranceInitialState from "./home-insurance-initial-state";
import {
    INITIALIZE_QUOTATION_FLOW,
    INITIALIZE_QUOTATION_FLOW_DONE,
    SAVE_PERSONAL_DATA,
    SAVE_PERSONAL_DATA_DONE,
    SAVE_HOUSING_INFO,
    SAVE_HOUSING_INFO_DONE,
    SAVE_GUESS_PRICE,
    SAVE_GUESS_PRICE_DONE,
    SAVE_PLAN_CUSTOM,
    SAVE_PLAN_CUSTOM_DONE,
    DO_PAYMENT,
    DO_PAYMENT_DONE,
    CALCULATE_HOME_PRICE,
    CALCULATE_HOME_PRICE_DONE,
    RESET_CALCULATOR,
    SET_REFERENTIAL_VALUE,
    SAVE_ADDRESS_INFO,
    SAVE_ADDRESS_INFO_DONE,
    OPEN_COVERAGE_INFO_MODAL,
    CLOSE_COVERAGE_INFO_MODAL,
    REQUEST_LOAD_COMPONENTS_PRELOADER,
    REQUEST_LOAD_QUOTE_POPUP,
    SUCCESS_LOAD_QUOTE_POPUP,
    SUCCESS_LOAD_COMPONENTS_PRELOADER,
    DISABLE_DEPENDENT_COVERAGES_DONE,
    LOAD_CHANNEL,
    LOAD_CHANNEL_DONE,
    SEND_ZOHO,
    SEND_ZOHO_DONE,
    UPDATE_ZOHO_DONE,
    UPDATE_CRM_DONE,
    UPDATE_HOUSING_VALUE,
    UPDATE_ASSETS_VALUE,
    START_QUOTE_PROCESS_DONE,
    whoCanHireModalSetOpen,
    securitySystemModalSetOpen,
    loadActivePromotionDone,
    validateIfDocumentNumberExistsDone,
    validateIfDocumentNumberExists,
    setFixedPlanSelection,
    SAVE_INITIAL_HOUSE_INFORMATION,
    sendCrmOracleGetCustomer,
    updateCrmOracle,
    updateCrmOracleOptyNumber,
} from "./home-insurance.actions";
import { arrayToMap } from "../../libs/helpers/object";

const homeInsuranceReducer = handleActions(
    {
        [INITIALIZE_QUOTATION_FLOW]: (state, action) => ({
            ...state,
            quotation: {
                ...state.quotation,
                initialQuotationForm: {
                    ...state.quotation.initialQuotationForm,
                    data: action.payload,
                    submitting: true,
                },
            },
            lazyComponents: {
                ...state.lazyComponents,
                preloadComponents: {
                    ...state.lazyComponents.preloadComponents,
                    isLoadRequested: true,
                },
            },
        }),
        [INITIALIZE_QUOTATION_FLOW_DONE]: {
            next: (state, { payload }) => ({
                ...state,
                quotation: {
                    ...state.quotation,
                    requestId: payload.requestId,
                    initialQuotationForm: {
                        ...state.quotation.initialQuotationForm,
                        data: {
                            ...state.quotation.initialQuotationForm.data,
                            birthDate:
                                payload.customer.birthDate ||
                                state.quotation.initialQuotationForm.data.birthDate,
                            documentNumber: payload.customer.documentId,
                            documentType: payload.customer.documentType,
                            email: payload.customer.email,
                            firstSurname:
                                payload.customer.firstSurname ||
                                state.quotation.initialQuotationForm.data.firstSurname,
                            lastSurname:
                                payload.customer.lastSurname ||
                                state.quotation.initialQuotationForm.data.lastSurname,
                            cellphone: payload.customer.mobile,
                            names:
                                payload.customer.names ||
                                state.quotation.initialQuotationForm.data.names,
                            nationality: payload.customer.nationality,
                            clientType: payload.clientType,
                            whichEnsure: payload.whichEnsure,
                            housingType: payload.housingType,
                        },
                        submitting: false,
                        done: true,
                    },
                },
            }),
            throw: (state, { payload }) => ({
                ...state,
                quotation: {
                    ...state.quotation,
                    initialQuotationForm: {
                        ...state.quotation.initialQuotationForm,
                        submitting: false,
                        error: payload,
                    },
                },
            }),
        },
        [SAVE_PERSONAL_DATA]: (state, { payload }) => ({
            ...state,
            quotation: {
                ...state.quotation,
                personalDataForm: {
                    ...state.quotation.personalDataForm,
                    submitting: true,
                    data: {
                        clientType: payload.clientType,
                        whichEnsure: payload.whichEnsure,
                        planType: payload.planType,
                        housingType: payload.housingType,
                    },
                },
            },
        }),
        [SAVE_PERSONAL_DATA_DONE]: {
            next: state => ({
                ...state,
                quotation: {
                    ...state.quotation,
                    personalDataForm: {
                        ...state.quotation.personalDataForm,
                        submitting: false,
                        done: true,
                    },
                },
            }),
            throw: (state, action) => ({
                ...state,
                quotation: {
                    ...state.quotation,
                    personalDataForm: {
                        ...state.quotation.personalDataForm,
                        submitting: false,
                        error: action.payload,
                    },
                },
            }),
        },
        [SAVE_INITIAL_HOUSE_INFORMATION]: (state, { payload }) => ({
            ...state,
            quotation: {
                ...state.quotation,
                housingInfoForm: {
                    ...state.quotation.housingInfoForm,
                    data: { ...payload, location: payload.location.value },
                },
                propertyData: {
                    submitting: true,
                },
            },
        }),
        [SAVE_HOUSING_INFO]: (state, { payload }) => ({
            ...state,
            quotation: {
                ...state.quotation,
                housingInfoForm: {
                    ...state.quotation.housingInfoForm,
                    data: { ...payload, location: payload.location.value },
                },
                propertyData: {
                    submitting: true,
                },
            },
        }),
        [SAVE_HOUSING_INFO_DONE]: {
            next: state => ({
                ...state,
                quotation: {
                    ...state.quotation,
                    housingInfoForm: {
                        ...state.quotation.housingInfoForm,
                        done: true,
                    },
                },
            }),
            throw: (state, action) => ({
                ...state,
                quotation: {
                    ...state.quotation,
                    housingInfoForm: {
                        ...state.quotation.housingInfoForm,
                        error: action.payload,
                    },
                    propertyData: {
                        submitting: false,
                    },
                },
            }),
        },
        [SAVE_GUESS_PRICE]: (state, { payload }) => ({
            ...state,
            quotation: {
                ...state.quotation,
                guessPriceForm: {
                    ...state.quotation.guessPriceForm,
                    data: {
                        ...state.quotation.guessPriceForm.data,
                        ...payload,
                    },
                    submitting: true,
                },
            },
        }),
        [SAVE_GUESS_PRICE_DONE]: {
            next: (
                state,
                {
                    payload: {
                        mainCoverage,
                        assistantPackage,
                        coverages,
                        fixedCoverages,
                        propertyInsuranceHasMinPrime,
                        belongingsInsuranceHasMinPrime,
                    },
                }
            ) => ({
                ...state,
                quotation: {
                    ...state.quotation,
                    propertyInsuranceHasMinPrime,
                    belongingsInsuranceHasMinPrime,
                    mainCoverage,
                    assistantPackage: null,
                    selectedCoverages: [],
                    guessPriceForm: {
                        ...state.quotation.guessPriceForm,
                        done: true,
                        submitting: false,
                    },
                    propertyData: {
                        submitting: false,
                    },
                },
                coverages,
                assistantPackage,
                fixedCoverages,
            }),
            throw: (state, action) => ({
                ...state,
                quotation: {
                    ...state.quotation,
                    guessPriceForm: {
                        ...state.quotation.guessPriceForm,
                        error: action.payload,
                        submitting: false,
                    },
                    propertyData: {
                        submitting: false,
                    },
                },
            }),
        },
        [UPDATE_HOUSING_VALUE]: (state, { payload }) => ({
            ...state,
            quotation: {
                ...state.quotation,
                guessPriceForm: {
                    ...state.quotation.guessPriceForm,
                    data: {
                        ...state.quotation.guessPriceForm.data,
                        housingValue: payload,
                    },
                },
            },
        }),
        [UPDATE_ASSETS_VALUE]: (state, { payload = "" }) => ({
            ...state,
            quotation: {
                ...state.quotation,
                guessPriceForm: {
                    ...state.quotation.guessPriceForm,
                    data: {
                        ...state.quotation.guessPriceForm.data,
                        assetValue: payload,
                    },
                },
            },
        }),
        [SAVE_PLAN_CUSTOM]: (state, { payload }) => ({
            ...state,
            quotation: {
                ...state.quotation,
                customPlanView: {
                    ...state.quotation.customPlanView,
                    submitting: true,
                },
                guessPriceForm: {
                    ...state.quotation.guessPriceForm,
                    data: {
                        ...state.quotation.guessPriceForm.data,
                        startEnsureDate: payload.startEnsureDate,
                    },
                },
            },
        }),
        [SAVE_PLAN_CUSTOM_DONE]: {
            next: (state, action) => ({
                ...state,
                quotation: {
                    ...state.quotation,
                    customPlanView: {
                        ...state.quotation.customPlanView,
                        done: true,
                    },
                    paymentForm: {
                        ...state.quotation.paymentForm,
                        totalPrice: action.payload.primeTotal,
                        totalPriceWithDiscount: action.payload.primeTotalDiscount,
                    },
                },
                paymentFees: action.payload.paymentFees,
            }),
            throw: (state, action) => ({
                ...state,
                quotation: {
                    ...state.quotation,
                    customPlanView: {
                        ...state.quotation.customPlanView,
                        error: action.payload.error,
                    },
                },
            }),
        },
        [START_QUOTE_PROCESS_DONE]: state => ({
            ...state,
            quotation: {
                ...state.quotation,
                customPlanView: {
                    ...state.quotation.customPlanView,
                    submitting: false,
                },
                propertyData: {
                    submitting: false,
                },
            },
        }),
        [DO_PAYMENT]: (state, action) => ({
            ...state,
            quotation: {
                ...state.quotation,
                paymentForm: {
                    ...state.quotation.paymentForm,
                    submitting: true,
                    data: action.payload,
                },
            },
        }),
        [DO_PAYMENT_DONE]: {
            next: (state, action) => ({
                ...state,
                quotation: {
                    ...state.quotation,
                    paymentForm: {
                        ...state.quotation.paymentForm,
                        submitting: false,
                        done: true,
                    },
                    paymentResult: {
                        ...state.quotation.paymentResult,
                        ...action.payload,
                    },
                },
            }),
            throw: (state, action) => ({
                ...state,
                quotation: {
                    ...state.quotation,
                    paymentForm: {
                        ...state.quotation.paymentForm,
                        submitting: false,
                        error: action.payload.message,
                    },
                },
            }),
        },
        TOGGLE_SELECTED_COVERAGE: (state, action) => {
            const { selected, coverage } = action.payload;
            return {
                ...state,
                quotation: {
                    ...state.quotation,
                    selectedCoverages: selected
                        ? [...state.quotation.selectedCoverages, coverage]
                        : state.quotation.selectedCoverages.filter(
                            cov => cov.id !== action.payload.coverage.id
                        ),
                },
                recommendedCoverages: {
                    ...state.recommendedCoverages,
                    showLabel: !state.recommendedCoverages.addedToList,
                },
            };
        },
        TOGGLE_SELECTED_MULTIPLE_COVERAGES: (state, action) => {
            const { selected, coverages } = action.payload;
            return {
                ...state,
                quotation: {
                    ...state.quotation,
                    selectedCoverages: selected
                        ? [...state.quotation.selectedCoverages, ...coverages]
                        : state.quotation.selectedCoverages.filter(
                            ({ id: id1 }) =>
                                !coverages.some(({ id: id2 }) => id2 === id1)
                        ),
                },
                recommendedCoverages: {
                    ...state.recommendedCoverages,
                    showLabel: !state.recommendedCoverages.addedToList,
                },
            };
        },
        TOGGLE_ASSISTANT_PACKAGE: (state, action) => ({
            ...state,
            quotation: {
                ...state.quotation,
                assistantPackage: action.payload.selected
                    ? state.assistantPackage
                    : undefined,
            },
            recommendedCoverages: {
                ...state.recommendedCoverages,
                showLabel: !state.recommendedCoverages.addedToList,
            },
        }),
        SET_UBIGEOS: (state, action) => ({
            ...state,
            ubigeos: action.payload,
            ubigeoMap: arrayToMap(action.payload, "ubigeo"),
        }),
        UPDATE_RECOMMENDED_COVERAGES: (state, action) => ({
            ...state,
            recommendedCoverages: {
                ...state.recommendedCoverages,
                ...action.payload,
            },
        }),
        UPDATE_QUOTATION_PRICE: (state, action) => ({
            ...state,
            quotation: {
                ...state.quotation,
                price: action.payload.price,
                hasMainPrimeMinPrime: action.payload.hasMainPrimeMinPrime,
                hasRobberyPrimeMinPrime: action.payload.hasRobberyPrimeMinPrime,
            },
        }),
        [CALCULATE_HOME_PRICE]: state => ({
            ...state,
            landing: {
                ...state.landing,
                calculator: {
                    ...state.landing.calculator,
                    submitting: true,
                },
            },
        }),
        [CALCULATE_HOME_PRICE_DONE]: {
            next: (state, action) => ({
                ...state,
                landing: {
                    ...state.landing,
                    calculator: {
                        ...state.landing.calculator,
                        submitting: false,
                        calculatedPrice: action.payload.response,
                        calculateTimes: state.landing.calculator.calculateTimes + 1,
                        housingType: action.payload.form.housingType,
                        squareMeters: action.payload.form.squareMeters,
                        location: action.payload.form.location,
                    },
                },
            }),
            throw: (state, action) => ({
                ...state,
                landing: {
                    ...state.landing,
                    calculator: {
                        ...state.landing.calculator,
                        submitting: false,
                        error: action.payload,
                        calculatedPrice: 0,
                        ubigeo: null,
                        calculateTimes:
                            state.landing.calculator.calculateTimes +
                            action.payload.increment,
                        housingType: action.payload.housingType,
                        squareMeters: action.payload.squareMeters,
                        location: action.payload.location,
                    },
                },
            }),
        },
        [SET_REFERENTIAL_VALUE]: {
            next: (state, action) => ({
                ...state,
                quotation: {
                    ...state.quotation,
                    guessPriceForm: {
                        ...state.quotation.guessPriceForm,
                        data: {
                            ...state.quotation.guessPriceForm.data,
                            housingValue: action.payload,
                        },
                    },
                },
            }),
            throw: state => ({
                ...state,
                quotation: {
                    ...state.quotation,
                    guessPriceForm: {
                        ...state.quotation.guessPriceForm,
                        data: {
                            ...state.quotation.guessPriceForm.data,
                            housingValue: 0.0,
                        },
                    },
                },
            }),
        },

        [RESET_CALCULATOR]: state => ({
            ...state,
            landing: {
                ...state.landing,
                calculator: {
                    ...state.landing.calculator,
                    calculateTimes: 0,
                    calculatedPrice: 0,
                },
            },
        }),

        [SAVE_ADDRESS_INFO]: (state, action) => ({
            ...state,
            quotation: {
                ...state.quotation,
                addressInfoForm: {
                    ...state.quotation.addressInfoForm,
                    data: action.payload,
                    submitting: true,
                },
            },
        }),

        [SAVE_ADDRESS_INFO_DONE]: {
            next: state => ({
                ...state,
                quotation: {
                    ...state.quotation,
                    addressInfoForm: {
                        ...state.quotation.addressInfoForm,
                        done: true,
                        submitting: false,
                    },
                },
            }),
            throw: (state, action) => ({
                ...state,
                quotation: {
                    ...state.quotation,
                    addressInfoForm: {
                        ...state.quotation.addressInfoForm,
                        submitting: false,
                        error: action.payload,
                    },
                },
            }),
        },

        [LOAD_CHANNEL]: (state, action) => ({
            ...state,
            channel: {
                ...state.channel,
                submitting: true,
            },
        }),

        [SEND_ZOHO]: (state, action) => ({
            ...state,
            channel: {
                ...state.channel,
            },
        }),

        [UPDATE_ZOHO_DONE]: {
            next: state => ({
                ...state,
            }),
            throw: state => ({
                ...state,
            }),
        },

        [SEND_ZOHO_DONE]: {
            next: (state, action) => ({
                ...state,
                channel: {
                    ...state.channel,
                    idZoho: action.payload.zohoId,
                },
            }),
            throw: state => ({
                ...state,
                channel: {
                    ...state.channel,
                    idZoho: "default",
                },
            }),
        },

        [LOAD_CHANNEL_DONE]: {
            next: (state, action) => {
                return {
                    ...state,
                    channel: {
                        ...state.channel,
                        partner: action.payload.form.partner,
                        partnerType: action.payload.form.partnerType,
                        chatAlowed: action.payload.form.chatAlowed,
                        submitting: false,
                    },
                };
            },
            throw: state => {
                return {
                    ...state,
                    channel: {
                        ...state.channel,
                        submitting: false,
                    },
                };
            },
        },

        [OPEN_COVERAGE_INFO_MODAL]: (state, action) => ({
            ...state,
            coverageInfoModal: {
                coverageCode: action.payload.coverageCode,
                variant: action.payload.variant,
                opened: true,
            },
        }),

        [CLOSE_COVERAGE_INFO_MODAL]: state => ({
            ...state,
            coverageInfoModal: {
                ...state.coverageInfoModal,
                opened: false,
            },
        }),
        [combineActions(
            REQUEST_LOAD_QUOTE_POPUP,
            SUCCESS_LOAD_QUOTE_POPUP,
            REQUEST_LOAD_COMPONENTS_PRELOADER,
            SUCCESS_LOAD_COMPONENTS_PRELOADER
        )]: (state, { payload }) => ({
            ...state,
            lazyComponents: {
                ...state.lazyComponents,
                ...payload,
            },
        }),
        [DISABLE_DEPENDENT_COVERAGES_DONE]: (state, { payload }) => ({
            ...state,
            quotation: {
                ...state.quotation,
                disabledCoverages: payload,
            },
        }),
        [whoCanHireModalSetOpen]: (state, { payload }) => ({
            ...state,
            landing: {
                ...state.landing,
                whoCanHire: {
                    ...state.landing.whoCanHire,
                    modal: {
                        opened: payload,
                    },
                },
            },
        }),
        [securitySystemModalSetOpen]: (state, { payload }) => ({
            ...state,
            securitySystemModal: {
                opened: payload,
            },
        }),
        [loadActivePromotionDone]: (state, { payload }) => ({
            ...state,
            activePromotion: payload,
            activePromotionDone: true,
        }),
        [validateIfDocumentNumberExists]: (state, { payload }) => ({
            ...state,
            quotation: {
                ...state.quotation,
                initialQuotationForm: {
                    ...state.quotation.initialQuotationForm,
                    documentNumberValidation: {
                        ...state.quotation.initialQuotationForm.documentNumberValidation,
                        loading: true,
                    },
                },
            },
        }),
        [validateIfDocumentNumberExistsDone]: {
            next: (state, { payload }) => ({
                ...state,
                isCustomerDocumentIdInvalid: false,
                quotation: {
                    ...state.quotation,
                    initialQuotationForm: {
                        ...state.quotation.initialQuotationForm,
                        documentNumberValidation: {
                            exists: payload,
                            loading: false,
                        },
                    },
                },
            }),
            throw: state => ({
                ...state,
                isCustomerDocumentIdInvalid: true,
                quotation: {
                    ...state.quotation,
                    initialQuotationForm: {
                        ...state.quotation.initialQuotationForm,
                        documentNumberValidation: {
                            exists: true,
                            loading: false,
                        },
                    },
                },
            }),
        },
        [setFixedPlanSelection]: (state, { payload }) => ({
            ...state,
            quotation: {
                ...state.quotation,
                customPlanView: {
                    ...state.quotation.customPlanView,
                    fixedPlan: {
                        ...payload,
                    },
                },
            },
        }),
        [sendCrmOracleGetCustomer]: (state, { payload }) => ({
            ...state,
        }),

        [updateCrmOracle]: (state, { payload }) => ({
            ...state,
            crmOracle: {
                ...state.crmOracle,
                partyId: payload,
                done: true
            },
        }),
        [updateCrmOracleOptyNumber]: (state, { payload }) => ({
            ...state,
            crmOracle: {
                ...state.crmOracle,
                optyNumber: payload,
            },
        }),
        [UPDATE_CRM_DONE]: {
            next: state => ({
                ...state,
            }),
            throw: state => ({
                ...state,
            }),
        },
    },
    homeInsuranceInitialState
);

export default homeInsuranceReducer;
